import { render } from "./create-hospital-modal.vue?vue&type=template&id=ce57b5e8"
import script from "./create-hospital-modal.vue?vue&type=script&lang=js"
export * from "./create-hospital-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__